module.exports = {
    webApp: 'Portal',
    company: 'threatER',
    companyLong: 'threatER',
    instance: 'Enforcer',
    instancePlural: 'Enforcers',
    software: 'Enforce',
    urlSupport: 'https://docs.threater.ai',
    urlTermsOfService: 'https://www.threater.com/terms-of-service',
}
